import { CircularProgress, Grid, Avatar, Tooltip } from '@mui/material';
import { AccountCircle, Email, VerifiedUser } from '@mui/icons-material';
import React, { useEffect, useRef, useState } from 'react'
import { StyledUserInfo } from './userInfo.style';
import HlxButton from 'component/commonComponents/button/button';

export interface IUserInfoProps {
  userInfo: any;
  loading: boolean;
  onClickLogout: () => void;
  color: string;
  locale: {
    logout: string;
    email: string;
    location: string;
    switchTenant: string;
    role: string;
  };
  userRoles: string;
};

const UserInfo = (props: IUserInfoProps) => {
  const { userInfo, loading, color, onClickLogout, locale, userRoles } = props;
  const [expanded, setExpanded] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        if (!expanded) return;
        setExpanded(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [ref, expanded]);

  return (
    <>
      <StyledUserInfo color={color} ref={ref} className="uptime-admin-user-info">
        <div className="user-info_section" onClick={() => setExpanded(!expanded)} id='dv-usersection-boxinfo'>
          <div className="user-info__avatar">
            {!!userInfo?.photo
              ? <Avatar src={userInfo?.photo} />
              : <AccountCircle className="user-avatar" />}
          </div>
        </div>
        {expanded && (
          <div className="user-info__overlay">
            {!loading ? (
              <Grid container spacing={2} direction="row">
                <Grid item container xs={12} alignItems="center" className="user-info__overlay-top">
                  {!!userInfo?.photo
                    ? <Avatar src={userInfo?.photo} />
                    : <AccountCircle />}
                  <span className="user-name">{userInfo?.name}</span>
                </Grid>
                <Grid item container xs={12}>
                  <Grid item container xs={5} alignItems="center" className="user-info__overlay-left">
                    <Email /> {locale.email}
                  </Grid>
                  <Grid item xs={7}>
                    <span className="user-info__overlay-right">{userInfo?.email}</span>
                  </Grid>
                </Grid>
                <Grid item container xs={12}>
                  <Grid item container xs={5} alignItems="center" className="user-info__overlay-left">
                    <VerifiedUser /> {locale.role}
                  </Grid>
                  <Grid item xs={7}>
                    <Tooltip title={userRoles} arrow>
                      <span className="user-info__overlay-right-roles">{userRoles}</span>
                    </Tooltip>
                  </Grid>
                </Grid>
                <Grid item container xs={12} justifyContent="center">
                  <HlxButton
                    fullWidth={false}
                    variant='outlined'
                    label={locale.logout}
                    onClick={onClickLogout}
                  />
                </Grid>
              </Grid>
            ) : (
              <div className="user-info__overlay-loading">
                <CircularProgress className="loading-icon" />
              </div>
            )}
          </div>
        )}
      </StyledUserInfo>
    </>
  )
};

export const defaultProps = {
  userInfo: {
    "uid": "0b85598cdb6291508a2c576ed396198a",
    "name": "Vinh Trinh",
    "user_name": "vinhngoc.trinh@dxc.com",
    "phone": "",
    "first_name": "Vinh",
    "last_name": "Trinh",
    "employee_number": "",
    "vip": "false",
    "photo": "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAgGBgcGBQgHBwcJCQgKDBQNDAsLDBkSEw8UHRofHh0aHBwgJC4nICIsIxwcKDcpLDAxNDQ0Hyc5PTgyPC4zNDL/2wBDAQkJCQwLDBgNDRgyIRwhMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjL/wAARCAAwADADASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwB1/qk6S7VvblXYnYrxrgkdqz0v7m+sZlldzKvOTxWjqghm16G4jlQBEbJHOWwB057VW+0mOXBMUm4kDcMZ/wDHa8+MtT2akLK6VtntZ/kjj72WVdQ/1zjcAeprVsDLIQPMYhmA4J6DrVzTLKzvvEYgvQqqYW2pn77A9Afpk9ulOmgi03UbqKGQPDCdoaTIIz275x61q5XgomCjy1ZTX9XCXUZzeNDAyJGowzMgbHrUlvqs4lUeYCrMAD5AGR+dNg/eFl8xBvGMeX1z/wABqzpcFqsDQyyLuIAG48k4/wAay5m5bmyhFQel7dl/mjVv7ZZPFEAuodxjg3MqpnLcdhWNcKILiZljJVpm2546AccjtXRXrQ3PjT7JL5m24DRh4nwV25bP6Vja/wDa005pIbVrgSTzFNr/AHF3DLHjjmpin+ZrKStbsl+TOx0bSNL0/TrO6utNa+1m/jzDEewYZwOygDktVu+8JWV5Z3ENzEDqsi7kdPlVSOgUd1HQk5JrW8OXDzaNZ392yPcPbIisEC7VwCQMds4/IVFrOoT2AXUIlDBIZmJIzjC7h+oFeilDk5raHjXm6lk9Tye3trcvcC5BjkBGARkqcc81ctrV8QmGzSXdLiQtGGOznnJ/OrF3ITLPeXEkiyY+0ssePm4yRj05q5Z3AWRMEKrRhuSB1rz1H318/wBT1pT/AHUrb2X6HL6zf6j/AGg1/BHFFdQENEUmDKcthv0J4pkfiaeOMw+YjxvuyOO+CcGu1bRV3sVjAz7VD/YkYPEMef8AcFdPslaxwfWZOXMzm7vx3f6etjZ6JdlY4oEikt5UDJv9sjr64PatC3+Ip1bSriy1BRFcumUe3j+XbxnIJ657ccViw6UZfigsATdDE5lbC/KCI+np1qPRNIMXjy9sZIsRxibYGXhhkEY/A/pWmlvZ36GN3fnILvVnnPlNMwC5QsmBuHp9KlXWHkkgX7GXVCoMgkABx0/wrsH8OwN1toif9wUxfDVuJFIt0GD/AAjFZ+yRr7d6+Z//2Q==",
    "mobile_phone": "",
    "avatar_name": "Vinh Trinh",
    "city": "",
    "state": "",
    "country": "",
    "department": "",
    "manager_email": "",
    "manager_uid": "",
    "manager_name": "",
    "manager_first_name": "",
    "manager_last_name": "",
    "location": "",
    "locationId": "",
    "email": "vinhngoc.trinh@dxc.com",
    "address": "",
    "last_verified": "2022-10-24T03:22:32.087Z"
  },
  loading: false,
  onClickLogout: () => { },
  color: "#000",
  locale: {
    "logout": "Logout",
    "email": "Email",
    "location": "Location",
    "switchTenant": "Switch Tenant",
    "role": "Role",
  }
};

UserInfo.defaultProps = defaultProps;

export default UserInfo;